import type { FaireProductEntity } from "../../entity_types/product";

export const p_dx6q8hmq3h: FaireProductEntity = {
  token: "p_dx6q8hmq3h",
  type: "product",
  name: "Saguaro National Park T-Shirt Arizona Desert Cactus Tee | Vintage Southwest Travel Souvenir Shirt | Tucson Nature Graphic",
  brandToken: "b_z962y8xcqr",
  brandName: "Textile Graphix",
  imageUrl:
    "https://cdn.faire.com/fastly/5ad1afb88cc22319ac9b71acbe057d85fe62f06295f03af077f5dae6e2ae78f9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1d92c8165684d5fecedde1dd4dfcedfc56d063e9a84685b832feddcd11d6acb8.jpeg",
    "https://cdn.faire.com/fastly/b92111a8d58bed44efe885d48642866ca372f4c21adc3544b4222929f73f271a.jpeg",
    "https://cdn.faire.com/fastly/25f91da3ea0997ea473272317569369535bfa82716495f9f140b1dbef45da7ab.jpeg",
    "https://cdn.faire.com/fastly/d11b1780ec7221a094465db431f78a1bb6307d91979a7789aa0d2b282121a070.jpeg",
    "https://cdn.faire.com/fastly/558f2d740e0f2aa3087a2b88e320e8925e2eb877906e18a059d1e5d16b52659b.jpeg",
    "https://cdn.faire.com/fastly/53d1784054ddfc3121000fe6b2f55ea577e069083548bafa7fc4e14a5c3f9c31.jpeg",
    "https://cdn.faire.com/fastly/b493dc0e4bd7f9e6054d784c038dd0de083fe8a1b930f8f14734c6f2145d5702.jpeg",
    "https://cdn.faire.com/fastly/5b0df3bceca60a84a9b0a0e982076e8258d9712fdb2efa3ba745eba9674cf553.jpeg",
    "https://cdn.faire.com/fastly/b7ba70365d5ffe1efd3b3f1ac1602aff2a6c389ed490b62acdecc56af408fa64.jpeg",
  ],
  priceDollars: 23.49,
  description:
    "Celebrate the iconic beauty of the Arizona desert with this vintage-style Saguaro National Park T-shirt. Featuring towering saguaro cacti beneath a warm desert sunset, this design captures the timeless stillness and bold character of the Southwest landscape.\n\nSoft, comfortable, and designed with a classic distressed finish, this tee makes a meaningful Arizona travel souvenir or a thoughtful gift for hikers, desert lovers, and national park adventurers who feel inspired by wide-open skies.\n\n✔ Vintage Saguaro desert artwork\n✔ Comfortable unisex fit\n✔ Perfect Arizona travel keepsake\n✔ Great gift for Southwest & park lovers\n\nPrinted on Comfort Colors® blanks with soft-hand ink, it’s as cozy and calming as the otter itself. Add your location, phrase, or date to create a truly personal piece. MOQ 32 per design.\n\nProduct Features: 100% ring-spun cotton (Comfort Colors® blank) Garment-dyed for a vintage, relaxed finish Oversized unisex fit Original artwork by in-house designers Screen printed in-house with soft-hand ink MOQ 32 per design (includes custom text)\n\nSizes S-3XL Available - *Upcharge on the 2XL and 3XL\n",
  tags: [],
  msrpDollars: 46.97,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:53.214Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
